module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-9 columns"
  }, [_vm._v("\n            avant\n            "), _c('vue-cropper', {
    ref: "cropper",
    attrs: {
      "guides": true,
      "view-mode": 2,
      "drag-mode": "crop",
      "auto-crop-area": 0.5,
      "min-container-width": 250,
      "min-container-height": 180,
      "background": true,
      "rotatable": true,
      "src": this.imageToCrop,
      "alt": "Source Image",
      "cropmove": this.cropImage
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns large-3 large-offset-8"
  }, [_c('button', {
    staticClass: "full-width",
    on: {
      "click": _vm.rotate
    }
  }, [_vm._v("Rotation")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "large-3 columns"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_vm._v("\n              après\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('img', {
    staticStyle: {
      "width": "200px",
      "height": "150px",
      "border": "1px solid gray"
    },
    attrs: {
      "src": _vm.cropImg,
      "alt": "Cropped Image"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "full-width",
    on: {
      "click": _vm.importCropped
    }
  }, [_vm._v("Valider")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "full-width",
    on: {
      "click": _vm.ImportFull
    }
  }, [_vm._v("Importer sans retouches")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "full-width light-grey-button",
    on: {
      "click": function($event) {
        return _vm.$emit('closeCropper')
      }
    }
  }, [_vm._v("Abandonner")])])])]), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0730e6d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/image-editor/image-cropper.vue
// module id = 702
// module chunks = 0